// Imports
import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { Router } from '@angular/router';
// Services
import { BasketService, DataStoreService } from '../../services';

@Component({
  selector: 'app-booking-details',
  templateUrl: './booking-details.component.html',
  styleUrls: ['./booking-details.component.css']
})

export class BookingDetailsComponent implements OnInit {
  constructor(
    private DataStore: DataStoreService,
    private basketService: BasketService,
    private router: Router,
    private cdref: ChangeDetectorRef
  ) { }

  contactNumberModel;
  submitted = false;
  countryStore;
  emailRegex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
  phoneRegex = /[0-9]/;
  loadIssue: boolean;
  nonWhitespaceRegExp: RegExp = new RegExp("\\S");
  initialCountry;

  // Define form
  clientForm: FormGroup = new FormGroup({
    surname: new FormControl('', [Validators.required, Validators.pattern(this.nonWhitespaceRegExp)]),
    forenameOne: new FormControl('', [Validators.required, Validators.pattern(this.nonWhitespaceRegExp)]),
    forenameTwo: new FormControl(''),
    applicantPresent: new FormControl(false),
    telephone: new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(15), Validators.pattern(this.phoneRegex)]),
    telephonePrefix: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required, Validators.pattern(this.emailRegex)]),
    confirmEmail: new FormControl('', [Validators.required, Validators.pattern(this.emailRegex)]),
  }, {
    validators: this.matchingEmailsValidator('email', 'confirmEmail')
  });

  @ViewChild('contactNumber') input: ElementRef;
  @ViewChild('phoneInput') phoneInput: ElementRef;

  // Getter for easy access to form fields
  get form() { return this.clientForm.controls; }

  async ngOnInit() {
    this.initialCountry = 'ie';
    if (this.DataStore.selectedLocation) {
      // Clear the basket
      this.basketService.deleteAllBaskets().catch(() => {
        this.loadIssue = true;
      });

      this.clientForm.patchValue({
        // add default telephone
        telephonePrefix: `+353`
      });

      this.DataStore.counters = await this.DataStore.selectedLocation.$getResources();

      // If the details have already been inputted, replace them
      const client = this.DataStore.clientDetails;
      if (this.DataStore.clientDetails) {
        this.clientForm.patchValue({
          surname: client.surname,
          forenameOne: client.forenameOne,
          forenameTwo: client.forenameTwo,
          applicantPresent: client.applicantPresent,
          telephone: client.telephone,
          telephonePrefix: client.telephonePrefix,
          email: client.email,
          confirmEmail: client.confirmEmail
        });

        if (this.DataStore.countryDetails) {
          this.initialCountry = this.DataStore.countryDetails.iso2;
        }

        // Key up event to change the country when going back
        var event;
        if (typeof (Event) === 'function') {
          event = new KeyboardEvent('keyup', { bubbles: true })
        } else {
          event = document.createEvent('Event');
          event.initEvent('keyup', true, true);
        }

        this.phoneInput.nativeElement.dispatchEvent(event);
      }

    } else {
      // Made it a function as back btn uses it too
      this.routerGoBack();
    }
  }

  // On input entry checks if email and confirm email match
  matchingEmailsValidator(emailKey: string, confirmEmailKey: string): ValidatorFn {
    return (group: FormGroup): { [key: string]: any } => {

      let email = group.controls[emailKey];
      let confirmEmail = group.controls[confirmEmailKey];

      // If the email and confirm email inputs have data
      if (email.value.length > 0 && confirmEmail.value.length > 0) {
        // Check if the emails match
        if (email.value !== confirmEmail.value) {
          confirmEmail.setErrors({ mismatch: true });
          return {
            mismatch: true
          };
        } else if (confirmEmail.errors && confirmEmail.errors.mismatch) {
          // If the errors object does not contain any other errors then set errors {} to null
          if (Object.keys(confirmEmail.errors).length == 1) {
            confirmEmail.setErrors(null);
          } else {
            // Delete the mismatch error from the object as we do not want to remove any other errors that exist in the {}
            delete confirmEmail.errors.mismatch;
          }
        }
      }
    };
  }

  proceed() {
    this.clientForm.markAllAsTouched();  // This line saved our lives, Marks all forms as clicked on for validation
    this.submitted = true;
    if (this.clientForm.invalid) {
      // scroll to the top of the page if form is invalid
      let scrollToTop = window.setInterval(() => {
        let pos = window.pageYOffset;
        if (pos > 0) {
          window.scrollTo(0, pos - 20);
        } else {
          window.clearInterval(scrollToTop);
        }
      }, 10);
      return;
    } else {
      // Store the client details in data store
      this.DataStore.clientDetails = this.clientForm.value;
      this.DataStore.countryDetails = this.countryStore;
      this.router.navigate(['/application-details']);
    }
  }

  countryChange(country: any) {
    this.countryStore = country;
    this.clientForm.patchValue({
      telephonePrefix: `+${country.dialCode}`
    });

    // Focus on the next label so screen2 readers dont get stuck inside the form input
    var element = document.getElementById('contactNumber_input');
    if (element) {
      if (!/^(?:a|select|input|button|textarea)$/i.test(element.tagName)) {
        element.tabIndex = -1;
      }
      element.focus();
    }
  }

  // Number input text validation
  keyPressNumberField(event: any) {
    // Test for digits only
    const pattern = /\D+/g;
    if (pattern.test(event.target.value)) {
      event.target.value = event.target.value.replace(/\D+/g, '');
    }
  }

  // stop typing inside telephone prefix. Without making the form disabled or readonly.
  // Thats if the user can get past the blur...
  disallowPrefixType(event: any) {
    event.preventDefault();
    return false;
  }

  // If the lead booker checkbox is changed
  leadBookerChanged(event: any) {
    if (event == false) {
      if (this.DataStore.clientDetails) {
        this.DataStore.clientDetails.applicantPresent = false;
      }
    }
  }

  routerGoBack() {
    this.router.navigate(['/location']);
  }
}
